import React, { useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteQuestionReport,
  getAllQuestionReport,
} from "../../redux/services/reportSlice";
import { AiOutlineDelete } from "react-icons/ai";
import { CgEye } from "react-icons/cg";
import ConfirmationPage from "../../common/ConfirmationPage";
import { toast } from "react-toastify";
import Model from "../../common/Model";
import { exportToTablePDF } from "../../common/PdfFormat";

const QuestionReport = () => {
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [modelOpen, setModelOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const getQuestionReportData = useSelector(
    (state) => state?.report?.questionReport
  );
  const getQuestionReport = React.useCallback(async () => {
    try {
      await dispatch(
        getAllQuestionReport({ page: page + 1, limit: pageLimit })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit]);

  useEffect(() => {
    getQuestionReport();
  }, [getQuestionReport]);
  const deleteQuestionData = async () => {
    try {
      const response = await dispatch(deleteQuestionReport(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getQuestionReport();
    } catch (error) {}
  };

  const QuestionColumns = [
    {
      label: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1 || index + 1,
    },
    {
      label: "Name",
      key: "userName",
      render: (_, row) => {
        if (!row?.user) {
          return "-";
        }
        return `${row?.user?.firstName + " " + row?.user?.lastName}`;
      },
    },
    {
      label: "Email",
      key: "email",
      render: (_, row) => row?.user?.email || "-",
    },
    {
      label: "Ph No.",
      key: "contact",
      render: (_, row) =>
        row?.user?.contact?.mobile
          ? `${row?.user?.contact?.countryCode} ${row?.user?.contact?.mobile}`
          : "-",
    },
    {
      label: "Referral Code",
      key: "referral-code",
      render: (_, row) => row?.user?.referralCode || "-",
    },
    {
      label: "Balance",
      key: "balance",
      render: (_, row) => row?.user?.walletBalance || "-",
    },
  ];
  const actions = [
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
    {
      icon: <CgEye className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setDetails(row);
      },
    },
  ];
  const exportToPDF = () => {
    const headersConfig =QuestionColumns
    const data = getQuestionReportData?.question_report_data || [];
    exportToTablePDF({
      tableName: "Question Report",
      data,
      headersConfig,
      pdfName: "question_report.pdf",
    });
  };
  return (
    <div>
      <Table
        title="Question Report"
        columns={QuestionColumns}
        data={getQuestionReportData?.question_report_data || []}
        actions={actions}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageCount={getQuestionReportData?.state?.page_limit}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Question Report"
          confirm={confirm}
          onDelete={deleteQuestionData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <Model closeModal={() => setModelOpen(false)} title="Report Details">
          <div className="space-y-4">
            {details?.user && (
              <h3>
                <span className="font-bold"> Name :</span> 
                {details?.user?.firstName + " " + details?.user?.lastName}
              </h3>
            )}
            {details?.question?.englishQuestion?.question && (
              <h3>
                <span className="font-bold">Question :</span> 
                {details?.question?.englishQuestion?.question
                  ? details?.question?.englishQuestion?.question
                  : "-"}
              </h3>
            )}

            {details?.subject?.name && (
              <h3>
                <span className="font-bold"> Subject :</span> 
                {details?.subject?.name}
              </h3>
            )}
            {details?.message && (
              <h3>
                <span className="font-bold"> Message :</span> {details?.message}
              </h3>
            )}
          </div>
        </Model>
      )}
    </div>
  );
};

export default QuestionReport;
